import { AiOutput } from 'builder/modules/interview/types'

export const processedBlurCard = (results: AiOutput[]) => {
  if (results.length === 1) {
    results[0].blur = { describe: true }
  }

  if (results.length === 2) {
    results[1].blur = {
      quantitative: true,
      describe: true,
    }
  }

  if (results.length === 3) {
    results[0].blur = { describe: true }
    results[1].blur = {
      describe: true,
    }

    results[2].blur = {
      quantitative: true,
      describe: true,
    }
  }

  if (results.length === 4) {
    results[0].blur = { describe: true }
    results[1].blur = {
      describe: true,
    }

    results[2].blur = {
      quantitative: true,
      describe: true,
    }

    results[3].blur = {
      quantitative: true,
      describe: true,
    }
  }

  return results
}
